
import styled from 'styled-components'

export const Layout = styled.div<{ hasIntakeInfoBar?: boolean, hasKidBackground?: boolean, hasStaticBackground?: boolean}>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ hasKidBackground, hasStaticBackground }) => {
    if (hasKidBackground) {
      return `url(https://uci-images.s3-us-west-1.amazonaws.com/images/bgkids_anim.svg)`
    }
    if (hasStaticBackground) {
      return `url(https://uci-images.s3-us-west-1.amazonaws.com/css/bg-1-static.svg)`
    }
    return `url(https://uci-images.s3.amazonaws.com/css/bg-1.svg)`
  }};
  background-color: ${({ hasKidBackground }) => {
    if (hasKidBackground) {
      return '#89BCF6'
    }
    return '#FFFFFF'
  }};
  background-size: cover;
  background-position: 42% 0%;
  background-attachment: fixed;
  padding-top: ${({ hasIntakeInfoBar }) => hasIntakeInfoBar ? '128px' : '64px' };
`




// WEBPACK FOOTER //
// ./src/atoms/Layout/index.tsx